import { observer } from "mobx-react-lite"
import { IUser } from "../../interfaces"
import { Text } from "../."
import { UserIcon } from "./UserIcon"
interface IUserCardProps {
	user: IUser | null
}

export const UserCard = observer(({ user }: IUserCardProps) => {
	return (
		<div className="flex flex-row">
			<UserIcon displayName={user?.displayName ?? ""} url={user?.photoURL ?? ""} />

			<div className="ml-[24px] flex flex-col justify-center">
				<Text style="text-xl font-bold uppercase">{user?.displayName ?? ""}</Text>
				<Text style="text-sm">{user?.email ?? ""}</Text>
			</div>
		</div>
	)
})
